export class OrganizationUser {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "OrganizationUserStatus",
            "format": ""
        },
        {
            "name": "orgRoles",
            "baseName": "orgRoles",
            "type": "Array<OrganizationUserRole>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrganizationUser.attributeTypeMap;
    }
    constructor() {
    }
}
